export const debugRoute = {
    patterns: {
        debug: '/debug',
    },
};
